/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DropDown,
    ValidatedDropDownList,
    ValidatedDynamicList,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { PrescrItem, PrescrTradeOrg } from 'models/api/prescr';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import {
    QuestionariesTradeOrgsForm,
    QuestionariesTradeOrgsFormWrapper,
} from '../Questionary/Modal/QuestionariesTradeOrgsForm';

type PrescrModalContentProps = {
    prescrRuleTypes: DropDown[];
    coverageTypes: DropDown[];
    dictsLoading: boolean;
};

const PrescrModalContent = ({
    prescrRuleTypes,
    coverageTypes,
    dictsLoading,
}: PrescrModalContentProps) => {
    const { t } = useTranslation();
    const { watch } = useFormContext<PrescrItem>();

    const coverageType = watch('tradeOrgCoverage');
    return (
        <>
            <Row>
                <Col>
                    <ValidatedInput<PrescrItem>
                        type="checkbox"
                        name="isActive"
                        label={t('BackOfficeIsActive')}
                    />
                </Col>
            </Row>
            <hr />
            <Row>
                <Col>
                    <ValidatedDropDownList<PrescrItem>
                        label={t('BackOfficeRuleType')}
                        items={prescrRuleTypes}
                        isLoading={dictsLoading}
                        name="type"
                        isClearable={false}
                    />
                </Col>
                <Col>
                    <ValidatedDropDownList<PrescrItem>
                        label={t('BackOfficeTradeOrgCoverage')}
                        items={coverageTypes}
                        isLoading={dictsLoading}
                        name="tradeOrgCoverage"
                        isClearable={false}
                    />
                </Col>
                <Col>
                    <ValidatedInput<PrescrItem> name="priority" label={t('BackOfficePriority')} />
                </Col>
            </Row>
            {coverageType !== 'All' && (
                <Row>
                    <Col>
                        <ValidatedDynamicList<PrescrItem, PrescrTradeOrg>
                            formComponent={(props) => <QuestionariesTradeOrgsForm {...props} />}
                            wrapper={(props) => <QuestionariesTradeOrgsFormWrapper {...props} />}
                            emptyRecord={{
                                id: 0,
                                tradeOrgId: null,
                                outletId: null,
                            }}
                            name="tradeOrgs"
                            compareFunc={(a, b) => a?.tradeOrgId === b?.tradeOrgId}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

export default PrescrModalContent;
